// BranchPage.jsx
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchBranchesData } from "../../features/Branches/BranchSlice";
import BranchCard from "./BranchCard";
import { motion, AnimatePresence } from 'framer-motion';
import CountryTabs from "../Tabs/Tabs";
import { useTranslation } from "react-i18next";

const BranchPage = () => {
  const dispatch = useDispatch();
  const { branches, loading } = useSelector((state) => state.branches);
  const { i18n } = useTranslation();
  useEffect(() => {
    dispatch(fetchBranchesData());
  }, [dispatch, i18n.language]);
  const [countryId, setCountryId] = useState("all");

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="flex justify-center ">
        <CountryTabs setCountryId={setCountryId} />
      </div>
      <div className="mx-auto px-4 sm:px-6 lg:px-8 w-[95%]">


        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[1, 2, 3].map((i) => (
              <div key={i} className="animate-pulse bg-white rounded-3xl shadow-lg h-[500px]" />
            ))}
          </div>
        ) : (
          <AnimatePresence>
            <div className="grid mt-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 justify-items-center">
              {branches?.filter(function (filter) {
                return countryId != "all" ? filter.country_id == countryId : filter;
              })?.map((branch) => (
                <BranchCard key={branch.id} branch={branch} />
              ))}
            </div>
          </AnimatePresence>
        )}
      </div>
    </div>
  );
};

export default BranchPage;